import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'gold' | 'track' | 'outline';
  className?: string;
}
const tones: Record<string, string> = {
  gold: 'border-yellow-500/40 bg-yellow-500/10 text-yellow-200',
  track: 'border-red-600/50 bg-red-600/15 text-red-400',
  outline: 'border-zinc-800 bg-zinc-800 text-stone-400'
};
export function Pill({
  children,
  tone = 'gold',
  className = ''
}: PillProps) {
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} data-id="element-151" data-mp="1axmurxpgasm1">
      {children}
    </span>;
}